export { default } from './GridHotels.vue'
